import { useState } from "react";
import "../styles/main_layout.css";
import TitleBar from "./page_header/page_header";
import ScrollableLst from "./lst_widget/json_item_lst";
import EditorOptions from "./editor_options/editor_options";
import Editor from "./editor/editor";
// import Compare from "./compare/compare";
import Quicktype from "./quicktype/quicktype";
import Footer from "./footer/footer";

const MainLayout = () => {
    const [compareMode, setCompareMode] = useState(false);
    const [quicktypeMode, setQuicktypeMode] = useState(false);

    const showSplitView = compareMode || quicktypeMode;

    return (
        <div className="app-shell">
            <div className="workspace">
                <aside className="sidebar">
                    <TitleBar />
                    <div className="sidebar-body">
                        <ScrollableLst />
                    </div>
                </aside>

                <div className="editor-panel">
                    <EditorOptions
                        compareMode={compareMode}
                        onToggleCompare={() => {
                            setCompareMode(!compareMode);
                            setQuicktypeMode(false);
                        }}
                        quicktypeMode={quicktypeMode}
                        onToggleQuicktype={() => {
                            setQuicktypeMode(!quicktypeMode);
                            setCompareMode(false);
                        }}
                    />
                    <div className={`panel-canvas${showSplitView ? " split-view" : ""}`}>
                        {showSplitView ? (
                            <div className="split-layout">
                                <div className="split-left">
                                    <Editor />
                                </div>
                                <div className="split-right">
                                    {quicktypeMode ? <Quicktype /> : <Editor />}
                                </div>
                            </div>
                        ) : (
                            <Editor />
                        )}
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default MainLayout;
